/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var ApiSaleOrderStatus;
(function (ApiSaleOrderStatus) {
    ApiSaleOrderStatus["UNSPECIFIED"] = "SALE_ORDER_STATUS_UNSPECIFIED";
    ApiSaleOrderStatus["PENDING"] = "SALE_ORDER_STATUS_PENDING";
    ApiSaleOrderStatus["PROCESSING"] = "SALE_ORDER_STATUS_PROCESSING";
    ApiSaleOrderStatus["PAID"] = "SALE_ORDER_STATUS_PAID";
    ApiSaleOrderStatus["FULFILLING"] = "SALE_ORDER_STATUS_FULFILLING";
    ApiSaleOrderStatus["PARTIALLY_SHIPPED"] = "SALE_ORDER_STATUS_PARTIALLY_SHIPPED";
    ApiSaleOrderStatus["SHIPPED"] = "SALE_ORDER_STATUS_SHIPPED";
    ApiSaleOrderStatus["DELIVERED"] = "SALE_ORDER_STATUS_DELIVERED";
    ApiSaleOrderStatus["COMPLETED"] = "SALE_ORDER_STATUS_COMPLETED";
    ApiSaleOrderStatus["CANCELLED"] = "SALE_ORDER_STATUS_CANCELLED";
    ApiSaleOrderStatus["FAILED"] = "SALE_ORDER_STATUS_FAILED";
    ApiSaleOrderStatus["ON_HOLD"] = "SALE_ORDER_STATUS_ON_HOLD";
    ApiSaleOrderStatus["RETURNED"] = "SALE_ORDER_STATUS_RETURNED";
    ApiSaleOrderStatus["PARTIALLY_REFUNDED"] = "SALE_ORDER_STATUS_PARTIALLY_REFUNDED";
    ApiSaleOrderStatus["REFUNDED"] = "SALE_ORDER_STATUS_REFUNDED";
})(ApiSaleOrderStatus || (ApiSaleOrderStatus = {}));
export function ApiSaleOrderStatusFromJSON(json) {
    return ApiSaleOrderStatusFromJSONTyped(json, false);
}
export function ApiSaleOrderStatusFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function ApiSaleOrderStatusToJSON(value) {
    return value;
}
